import { render, staticRenderFns } from "./SortProductsList.vue?vue&type=template&id=c864be32"
import script from "./SortProductsList.vue?vue&type=script&lang=ts"
export * from "./SortProductsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports